import { Box, SlideFade } from '@chakra-ui/react';
import { PageContainer } from '@/components/PageContainer';
import { Footer } from '@/components/Footer';
import { SiteNav } from '@/components/Navbar/SiteNav';
import { PUBLIC_PAGE_CONTENT_PT } from '@/components/Navbar/siteNavLayout';
import { TeamDetailRoot } from '@/components/teamDetail';
import { useWc26GameResults } from '@/hooks/useWc26GameResults';
import { LEAGUE_PAGE_WIDE_MAX_W } from '@/views/LeaguePage/LeaguePageLayout';
import { AiLeaguePageContent } from './AiLeaguePageContent';

export default function AiLeaguePage() {
  const gameResults = useWc26GameResults();

  return (
    <TeamDetailRoot>
      <SlideFade in>
        <PageContainer>
          <SiteNav />
          <Box as='main' width='full' pb={10}>
            <Box maxW={LEAGUE_PAGE_WIDE_MAX_W} mx='auto' px={{ base: 4, md: 8, xl: 12 }} pt={PUBLIC_PAGE_CONTENT_PT}>
              <AiLeaguePageContent gameResults={gameResults} />
            </Box>
          </Box>
          <Footer />
        </PageContainer>
      </SlideFade>
    </TeamDetailRoot>
  );
}
